import React from "react";
import { Route, Navigate } from "react-router-dom";

// Basic PrivateRoute Component
const PrivateRoute = ({ element, ...rest }) => {
  // Check if token exists in localStorage
  const isAuthenticated = localStorage.getItem("token");

  // If not authenticated, redirect to login page
  return isAuthenticated ? element : <Navigate to="/login" />;
};

export default PrivateRoute;
